
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinecabbookingpune() {



  const cardData =
  {
    keyword: 'Online Cab Booking in Pune',
    heading: 'AB Ghule Cabs: Online Cab Booking in Pune',
    headingDescription: 'Looking to book a cab online in Pune? AB Ghule Cabs provides a quick, easy, and reliable online cab booking service for your convenience. Whether you are heading to the airport, going to a business meeting, or planning a day trip, our online booking system allows you to reserve a cab in just a few clicks. Enjoy a comfortable, safe, and affordable ride with our experienced drivers and well-maintained vehicles.',

    top: 'Top Places to Visit in Pune with AB Ghule Cabs',

    topPlaces: [
        {
            title: "Shaniwar Wada",
            description: "This historical fortification, located in the heart of Pune, is famous for its association with the Maratha empire. It’s a great place for history lovers and a must-see for visitors."
        },
        {
            title: "Aga Khan Palace",
            description: "Known for its elegant architecture and historical significance, Aga Khan Palace played a significant role during India's freedom struggle. The beautiful gardens and serene ambiance make it a peaceful destination."
        },
        {
            title: "Sinhagad Fort",
            description: "Situated on a hilltop, Sinhagad Fort is famous for its scenic views, historical significance, and trekking opportunities. It’s a popular spot for history enthusiasts and nature lovers."
        },
        {
            title: "Osho Ashram",
            description: "A renowned meditation center, Osho Ashram offers an escape into spirituality with its tranquil environment and meditation programs."
        },
        {
            title: "Dagdusheth Halwai Ganapati Temple",
            description: "One of Pune's most revered temples, Dagdusheth Halwai Ganapati Temple is a vibrant place of worship, especially during Ganesh Chaturthi."
        },
        {
            title: "Raja Dinkar Kelkar Museum",
            description: "Explore the rich cultural heritage of India through a variety of artifacts on display at this museum, which reflects the history and traditions of Maharashtra."
        },
        {
            title: "Pune Okayama Friendship Garden",
            description: "Inspired by Japanese garden design, this peaceful garden is perfect for a relaxing stroll amidst beautiful landscapes and serene water features."
        },
        {
            title: "Khadakwasla Dam",
            description: "A popular picnic spot, Khadakwasla Dam offers stunning views and boating options, making it an ideal destination for a relaxing day out."
        },
        {
            title: "Pune University",
            description: "Known for its beautiful campus and heritage, Pune University is a great place to explore the city's educational landmarks and scenic views."
        },
        {
            title: "FC Road (Fashion Street)",
            description: "For those looking to indulge in shopping, FC Road offers an array of shops, street markets, and eateries, making it one of Pune's most bustling streets."
        }
    ]
    ,


    services: [
        {
          "name": "Online Cab Booking Pune",
          description: "Book your cab online with AB Ghule Cabs for a hassle-free experience in Pune. Whether it's a local or outstation trip, enjoy comfortable rides with professional drivers and well-maintained vehicles."
        },
        {
          "name": "Taxi Booking Pune",
          description: "For easy and convenient taxi booking in Pune, AB Ghule Cabs is your go-to choice. Our online booking service makes it simple to book a reliable taxi for any of your travel needs in Pune."
        },
        {
          "name": "Cab Booking Website in Pune",
          description: "Visit AB Ghule Cabs’ website for easy cab bookings in Pune. Our website offers seamless online booking options for both local and outstation trips, ensuring a smooth and comfortable ride."
        },
        {
          "name": "Online Taxi Booking Pune",
          description: "AB Ghule Cabs offers online taxi booking in Pune for your convenience. Book a reliable and comfortable taxi for your local or outstation journey at the best rates."
        },
        {
          "name": "Mumbai Airport to Pune Taxi Online Booking",
          description: "Book a taxi from Mumbai Airport to Pune online with AB Ghule Cabs. Our taxi service offers timely and comfortable rides, ensuring a smooth and convenient transfer from Mumbai Airport to Pune."
        },
        {
          "name": "Online Cab Booking Mumbai to Pune",
          description: "Looking to travel from Mumbai to Pune? Book an online cab with AB Ghule Cabs. We provide a reliable, comfortable, and affordable taxi service between Mumbai and Pune, with professional drivers ensuring a smooth journey."
        },
        {
          "name": "Online Cab Service in Pune",
          description: "AB Ghule Cabs offers efficient and reliable online cab services in Pune. Whether you need a ride for local sightseeing or a longer journey, we ensure comfort and safety with easy online booking."
        },
        {
          "name": "Online Cabs in Pune",
          description: "Book online cabs in Pune with AB Ghule Cabs for a convenient and smooth travel experience. We offer well-maintained vehicles and professional drivers to cater to all your travel needs."
        },
        {
          "name": "Online Car Booking in Pune",
          description: "Book a car online in Pune with AB Ghule Cabs for your outstation or local travel. Our booking system is quick and easy, offering a wide range of vehicles to suit your needs."
        },
        {
          "name": "Online Taxi Pune",
          description: "For reliable online taxi booking in Pune, AB Ghule Cabs is the ideal choice. Our online service allows you to easily book a taxi for all your local and outstation journeys with a few clicks."
        },
        {
          "name": "Taxi Booking in Pune",
          description: "Book your taxi in Pune with AB Ghule Cabs for a comfortable and affordable ride. Our taxi booking service ensures you get a reliable vehicle and professional driver for all your travel needs."
        },
        {
          "name": "Pune to Shirdi Cab Booking Online",
          description: "Book your Pune to Shirdi cab online with AB Ghule Cabs. Our online booking system makes it simple and convenient to secure a comfortable and affordable ride for your trip to Shirdi."
        },
        {
          "name": "Online Cab Service Pune",
          description: "AB Ghule Cabs offers excellent online cab services in Pune. Our easy-to-use online booking platform ensures you can book a cab for local or outstation travel with ease and confidence."
        },
        {
          "name": "Online Cab Service Pimpri Chinchwad",
          description: "For reliable online cab services in Pimpri Chinchwad, book with AB Ghule Cabs. We offer convenient booking and timely services for all your local and long-distance travel needs."
        },
        {
          "name": "Online Cab Service Viman Nagar",
          description: "Book your online cab service in Viman Nagar with AB Ghule Cabs. We provide reliable, affordable, and timely taxi services, ensuring comfort and safety for your travel needs."
        },
        {
          "name": "Online Tempo Traveller Booking in Pune",
          description: "Book an online Tempo Traveller in Pune with AB Ghule Cabs for your group travel. Our Tempo Travellers are spacious and comfortable, perfect for long trips, family outings, or corporate events."
        },
        {
          "name": "Online Cab Booking Pune Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Online Cab Booking Pune. We ensure a smooth and enjoyable ride for all our customers."
        }
      ],

      tableData : [
        ["- Online Cab Booking Pune", "- Taxi Booking Pune"],
        ["- Cab Booking Website in Pune", "- Online taxi booking pune"],
        ["- Mumbai airport to pune taxi online booking", "- Online cab booking mumbai to pune"],
        ["- Online cab service in pune", "- Online cabs in pune"],
        ["- Online car booking in pune", "- Online taxi pune"],
        ["- Taxi booking in pune", "- Pune to shirdi cab booking online"],
        ["- Online cab service pune", "- Online cab service pimpri chinchwad"],
        ["- Online cab service Viman Nagar", "- Online tempo traveller booking in Pune"]
      ],
      
      whychoose: [
        {
          WhyChooseheading: "Reliable and Professional Service",
          WhyChoosedescription: "AB Ghule Cabs offers dependable and professional online cab booking services in Pune. Our well-trained drivers ensure that your ride is safe, comfortable, and timely, whether you need a ride for local travel, airport transfers, or outstation trips."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "We are available around the clock to cater to your travel needs. Whether you need an early morning ride or a late-night pickup, you can rely on AB Ghule Cabs for hassle-free service at any time of the day."
        },
        {
          WhyChooseheading: "Affordable Rates",
          WhyChoosedescription: "We offer competitive and transparent pricing with no hidden charges, ensuring that you get the best value for your money. Whether you're traveling alone or in a group, we have affordable options to suit your budget."
        },
        {
          WhyChooseheading: "Wide Range of Vehicles",
          WhyChoosedescription: "From economy sedans to spacious SUVs and luxury cars, we offer a variety of vehicles to meet your specific needs. Choose the vehicle that best suits your preferences for a comfortable ride within Pune or for trips outside the city."
        },
        {
          WhyChooseheading: "Safe and Comfortable Rides",
          WhyChoosedescription: "Our drivers are experienced, professional, and background-checked to ensure your safety and comfort. The vehicles are regularly maintained, ensuring a smooth ride every time you book with us."
        },
        {
          WhyChooseheading: "Easy and Convenient Online Booking",
          WhyChoosedescription: "Booking a cab online with AB Ghule Cabs is quick and easy. You can reserve your ride through our user-friendly website or mobile app. The booking process is simple, allowing you to schedule your ride in just a few clicks."
        },
        {
          WhyChooseheading: "Customer Satisfaction",
          WhyChoosedescription: "Our focus is on providing excellent customer service and ensuring that your ride experience is seamless and enjoyable. With numerous positive reviews, AB Ghule Cabs is trusted by travelers in Pune for their cab booking needs."
        }
      ]
      
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab online with AB Ghule Cabs?',
      answer: 'You can easily book your cab online through our website or mobile app. Simply select your pickup location, destination, and preferred vehicle, and your booking will be confirmed in a few steps.',
    },
    {
      id: 'FAQ2',
      question: 'Are your drivers experienced and trustworthy?',
      answer: 'Yes, all of our drivers are professional, experienced, and background-checked to ensure a safe and pleasant journey for you.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for online booking?',
      answer: 'We offer a variety of vehicles, including budget sedans, SUVs, and luxury cars. You can choose the vehicle that fits your needs, whether you are traveling alone or with a group.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my ride?',
      answer: 'You can pay for your ride using various payment methods, including cash, credit/debit cards, or online payment options through our app or website, providing flexibility and convenience.',
    },
    {
      id: 'FAQ5',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours, but we ensure full transparency. Any extra charges will be communicated to you upfront during the booking process.',
    },
    {
      id: 'FAQ6',
      question: 'Can I cancel or modify my booking?',
      answer: 'Yes, you can easily modify or cancel your booking through our website or mobile app. You can also contact our customer service team if you need assistance with changes or cancellations.',
    },
    {
      id: 'FAQ7',
      question: 'Do you offer one-way and round-trip services?',
      answer: 'Yes, we provide both one-way and round-trip services for your convenience. Choose the best option based on your travel needs, whether it\'s for a local trip in Pune or an outstation journey.',
    },
    {
      id: 'FAQ8',
      question: 'Is AB Ghule Cabs available for group travel?',
      answer: 'Yes, we offer spacious vehicles for group travel, whether it’s for a family outing, corporate event, or friends\' trip. We ensure a comfortable and enjoyable ride for everyone in your group.',
    },
    {
      id: 'FAQ9',
      question: 'What makes AB Ghule Cabs different from other online cab booking services?',
      answer: 'AB Ghule Cabs stands out for its reliability, transparent pricing, professional drivers, well-maintained fleet, and excellent customer service. We prioritize your safety, comfort, and satisfaction on every ride.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Ravi Sharma",
      feedback: "I booked a cab online with AB Ghule Cabs for a business trip within Pune. The whole process was so simple and convenient, and the driver arrived on time. The ride was comfortable, and I was very impressed with the service.",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Aditi Singh",
      feedback: "I used the AB Ghule Cabs app to book a ride to the airport, and it was an excellent experience. The app was easy to use, the driver was professional, and the vehicle was clean and comfortable. Highly recommend this service!",
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Online Cab Booking in Pune | Book Cabs for Local & Outstation</title>
  <meta name="description" content="Book cabs online in Pune for local and outstation trips. Offering easy online taxi booking for Mumbai to Pune, Pune to Shirdi, and more. Call +91 8624029699 for booking." />
  <meta name="keywords" content="Online cab booking Pune, Taxi booking Pune, Cab booking website in Pune, Online taxi booking Pune, Mumbai airport to Pune taxi online booking, Online cab booking Mumbai to Pune, Online cab service in Pune, Online cabs in Pune, Online car booking in Pune, Online taxi Pune, Taxi booking in Pune, Pune to Shirdi cab booking online, Online cab service Pune, Online cab service Pimpri Chinchwad, Online cab service Viman Nagar, Online tempo traveller booking in Pune" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Online Cab Booking in Pune | Book Cabs for Local & Outstation" />
  <meta property="og:description" content="Book cabs online in Pune for local and outstation trips. Offering easy online taxi booking for Mumbai to Pune, Pune to Shirdi, and more. Call +91 8624029699 for booking." />
  <meta property="og:image" content="https://abghulecabs.com/images/online-cab-booking-pune.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/online-cab-booking-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "TaxiService",
        "name": "AB Ghule Cabs - Online Cab Booking in Pune",
        description: "Book cabs online in Pune for local and outstation trips. Offering easy online taxi booking for Mumbai to Pune, Pune to Shirdi, and more. Call +91 8624029699 for booking.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/online-cab-booking-pune",
        "logo": "https://abghulecabs.com/images/online-cab-booking-pune.jpg",
        "image": "https://abghulecabs.com/images/online-cab-booking-pune.jpg",
        "priceRange": "₹1200 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/online-cab-booking-pune",
          "priceCurrency": "INR",
          "price": "1200",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "300"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya M"
            },
            "datePublished": "2024-07-15",
            "reviewBody": "Booking a cab online was quick and easy. I traveled from Pune to Shirdi with AB Ghule Cabs. The ride was comfortable and safe. Highly recommend their service!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Karan S"
            },
            "datePublished": "2024-08-30",
            "reviewBody": "Booked a cab online for a trip from Mumbai to Pune. Great service, on-time pickup, and hassle-free booking process. Will use again."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and surrounding areas",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/online-cab-booking-pune"
        },
        "keywords": "Online cab booking Pune, Taxi booking Pune, Cab booking website in Pune, Online taxi booking Pune, Mumbai airport to Pune taxi online booking, Online cab booking Mumbai to Pune, Online cab service in Pune, Online cabs in Pune, Online car booking in Pune, Online taxi Pune, Taxi booking in Pune, Pune to Shirdi cab booking online, Online cab service Pune, Online cab service Pimpri Chinchwad, Online cab service Viman Nagar, Online tempo traveller booking in Pune"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/66.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Onlinecabbookingpune;